const prefix = (type) => `eureka/groups/${type}`;

export const LOAD_ALL_KIDS_START = prefix('LOAD_ALL_KIDS_START');
export const LOAD_ALL_KIDS_SUCCESS = prefix('LOAD_ALL_KIDS_SUCCESS');
export const LOAD_ALL_KIDS_FAILED = prefix('LOAD_ALL_KIDS_FAILED');

export const LOAD_ALL_KIDS_REPORTS_START = prefix('LOAD_ALL_KIDS_REPORTS_START');
export const LOAD_ALL_KIDS_REPORTS_SUCCESS = prefix('LOAD_ALL_KIDS_REPORTS_SUCCESS');
export const LOAD_ALL_KIDS_REPORTS_FAILED = prefix('LOAD_ALL_KIDS_REPORTS_FAILED');
